import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";

export default function ScopeBanner({ children, variant = "info", "data-testid": testId }) {
  const { t } = useTranslation();
  const styles =
    variant === "warn"
      ? "bg-amber-50 border-amber-200 text-amber-900"
      : "bg-salnes-sand/40 border-salnes-sand text-salnes-ink";
  return (
    <div
      role="status"
      data-testid={testId || "scope-banner"}
      className={`flex items-start gap-3 rounded-xl border px-4 py-3 text-sm ${styles}`}
    >
      <AlertTriangle size={16} className="mt-0.5 shrink-0" />
      <div className="leading-snug">
        {children || t("fase2.scope_notice")}
      </div>
    </div>
  );
}

export function DemoBadge() {
  // Deprecated — plataforma en modo producción con datos reales o empty states.
  // Se mantiene el export como no-op para compatibilidad con importaciones legadas.
  return null;
}
